import React from "react";
import MvModal from '../MvModal'
// @ts-ignore
import { LocalizationContext } from 'react-localize';
// Styles
import "./MvConfirmationModal.sass"

interface Props {
    header?: string;
    description: string;
    message: string;
    abortLabel?: string;
    confirmLabel: string;
    openModal: boolean;
    toggleModal: () => void;
    abort: () => void;
    confirm: () => void;
};

class MvConfirmationModal extends React.Component<Props, {}> {

    render() {
        const { localize } = this.context;
        let modalBody;
        if (this.props.description) {
            modalBody = (
                <div className='modal-body'
                    dangerouslySetInnerHTML={{
                        __html: localize(this.props.description)
                    }}
                >
                </div>
            );
        }
        return (
            <MvModal
                id="ayp-modal"
                openModal={this.props.openModal}
                toggleModal={this.props.toggleModal}>
                <div className="mv-confirmation-modal">
                    <div className='modal-header'>
                        {this.props.header ? <p className="headline">{localize(this.props.header)}</p>: "" }
                        <p className="headline">{localize(this.props.message)}</p>
                    </div>
                    {modalBody}
                    <div className='modal-footer'>
                        <div className=''>
                            <button
                                type='button'
                                className='mv-button primary underline'
                                ref='confirm'
                                onClick={this.props.confirm}
                            >
                                {localize(this.props.confirmLabel)}
                            </button>
                            {this.props.abortLabel &&
                                <button
                                    type='button'
                                    className='mv-button primary'
                                    onClick={this.props.abort}
                                >
                                    {localize(this.props.abortLabel)}
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </MvModal>
        );
    }
};

MvConfirmationModal.contextType = LocalizationContext;
export {
    MvConfirmationModal,
};
